import { render, staticRenderFns } from "./managePublisher.vue?vue&type=template&id=97445f4e&"
import script from "./managePublisher.vue?vue&type=script&lang=js&"
export * from "./managePublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports